import { BookmarkCollectionRequestInterface } from "@/components/common/api/interface";
import { TYPE_ARTICLE, TYPE_VIDEO } from "@/helpers/constants";
import { NEXT_PUBLIC_GATEWAY_API_DOMAIN } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";

export const BookmarkCollectionItemApi = async (props: BookmarkCollectionRequestInterface) => {
  const { authToken, type, itemId, action } = props;

  if (!action) return false;

  let body = {};

  if (type === TYPE_ARTICLE) {
    body = { ...body, articleId: itemId };
  }

  if (type === TYPE_VIDEO) {
    body = { ...body, videoId: itemId };
  }

  const endPoint = action === "add" ? "savedCollection/add" : "savedCollection/remove";
  const API_URL = `${`${NEXT_PUBLIC_GATEWAY_API_DOMAIN}/mom-baby-auth/${endPoint}`}`;

  return await fetchUtil({
    url: API_URL,
    method: "POST",
    body: body,
    useToken: true,
    token: authToken,
    credentials: "",
    ctype: "",
  });
};
